import React from 'react';
import classNames from 'classnames';
import { DataRoomNodeWithStateAndSignal, Lead } from 'models/Lead';
import ReleaseFileInstance from './components/ReleaseFileInstance';

import './ReleaseFiles.styles.scss';

type ReleaseFilesProps = {
  className?: string;
  disabled?: boolean;
  leadId: string;
  dataRoomNodesWithStateAndSignal: DataRoomNodeWithStateAndSignal[];
  onSuccessRelease?: (lead: Lead) => void;
};

const ReleaseFiles: React.FC<ReleaseFilesProps> = (props) => {
  const {
    className,
    leadId,
    dataRoomNodesWithStateAndSignal,
    disabled = false,
    onSuccessRelease,
  } = props;

  const classes = classNames('release-files', className);

  return (
    <div className={classes}>
      {dataRoomNodesWithStateAndSignal.map((dataRoomNodeWithStateAndSignal) => (
        <ReleaseFileInstance
          disabled={disabled}
          key={dataRoomNodeWithStateAndSignal.dataRoomNodeId}
          leadId={leadId}
          dataRoomNodeWithStateAndSignal={dataRoomNodeWithStateAndSignal}
          onSuccessRelease={onSuccessRelease}
        />
      ))}
    </div>
  );
};

export default ReleaseFiles;
